import { Fragment, useState, useEffect } from 'react';
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { getListPrinters, deletePrinter } from "actions/printerActions";
import { Modaladdprinter } from "./modal";
import cx from "classnames";
// import { useTranslation } from "react-i18next";

function Listprinters(props) {
    const [isOpenModalAddPrinter, setIsOpenModalAddPrinter] = useState(false);
    const [printer_selected, setPrinterSelected] = useState(false);
    const [allPrinters, setAllPrinters] = useState([{
        value: "cotik",
        label: "Cotik Partner",
        description: "",
        logo: "cotik.png",
        enable: false
    }, {
        value: "mmotaxhub",
        label: "MMO Tax Hub",
        description: "No Printer, only sync Finance",
        logo: "mmotaxhub.png",
        enable: false
    }, {
        value: "flashship",
        label: "Flashship",
        description: "",
        logo: "flashship_3.png",
        enable: false
    }, {
        value: "mangoteeprints",
        label: "Mangoteeprints",
        description: "",
        logo: "mangoteeprints_3.png",
        enable: false
    }, {
        value: "gearment",
        label: "Gearment",
        description: "",
        logo: "gearment_3.png",
        enable: false
    }, {
        value: "hmfulfill",
        label: "HM Fulfill",
        description: "",
        logo: "hmfulfill_3.png",
        enable: false
    }, {
        value: "lenful",
        label: "Lenful",
        description: "",
        logo: "lenful_3.png",
        enable: false
    }, {
        value: "onospod",
        label: "OnosPOD",
        description: "",
        logo: "onospod_3.png",
        enable: false
    }, {
        value: "a2kecom",
        label: "A2K Ecom",
        description: "",
        logo: "a2k.png",
        enable: false
    }, {
        value: "printeeshub",
        label: "Printeeshub",
        description: "",
        logo: "printeeshub_3.png",
        enable: false
    }, {
        value: "monkeykingprint",
        label: "Monkeykingprint",
        description: "",
        logo: "monkeykingprint.png",
        enable: false
    }, {
        value: "kvfulfill",
        label: "KV Fulfill",
        description: "",
        logo: "kv_2.png",
        enable: false
    }, {
        value: "visiovsolutions",
        label: "VisiovSolutions",
        description: "",
        logo: "image.png",
        enable: false
    }, {
        value: "saigongroups",
        label: "Saigongroups.us",
        description: "",
        logo: "saigongroups.png",
        enable: false
    }, {
        value: "burgerprints",
        label: "Burgerprints",
        description: "",
        logo: "burgerprints.png",
        enable: false
    }, {
        value: "printify",
        label: "Printify",
        description: "",
        logo: "printify.png",
        enable: false
    }, {
        value: "oneprint",
        label: "Oneprint",
        description: "",
        logo: "oneprint_2.png",
        enable: false
    }, {
        value: "opcreative",
        label: "OP Creative",
        description: "",
        logo: "opcreative_2.png",
        enable: false
    }, {
        value: "menprint",
        label: "Menprint",
        description: "",
        logo: "menprint.png",
        enable: false
    }, {
        value: "teroprints",
        label: "Teroprints",
        description: "",
        logo: "teroprints.png",
        enable: false
    }, {
        value: "fprint",
        label: "Fprint",
        description: "",
        logo: "fprint.png",
        enable: false
    }, {
        value: "printsel",
        label: "Printsel",
        description: "",
        logo: "printsel.png",
        enable: false
    }, {
        value: "tebprint",
        label: "Tebprint",
        description: "",
        logo: "tebprint.png",
        enable: false
    }, {
        value: "printiz",
        label: "Printiz",
        description: "",
        logo: "printiz.png",
        enable: false
    }, {
        value: "merchize",
        label: "Merchize",
        description: "",
        logo: "merchize.png",
        enable: false
    }, {
        value: "saigongroupsnet",
        label: "Saigongroups.net",
        description: "",
        logo: "image.png",
        enable: false
    }, {
        value: "pressify",
        label: "Pressify",
        description: "",
        logo: "pressify.png",
        enable: false
    // }, {
    //     value: "thgfulfill",
    //     label: "THG Fulfill",
    //     description: "",
    //     logo: "thgfulfill.png",
    //     enable: false
    }, {
        value: "smartfactore",
        label: "Smartfactore",
        description: "",
        logo: "image.png",
        enable: false
    }, {
        value: "viettelpost_1",
        label: "Viettelpost 1",
        description: "",
        logo: "viettelpost.png",
        enable: false
    }, {
        value: "viettelpost_2",
        label: "Viettelpost 2",
        description: "",
        logo: "viettelpost.png",
        enable: false
    }, {
        value: "lizyprintfull",
        label: "Lizyprintfull",
        description: "",
        logo: "lizyprintfull.png",
        enable: false
    }, {
        value: "sellerwix",
        label: "Sellerwix",
        description: "",
        logo: "sellerwix.png",
        enable: false
    }, {
        value: "anprints",
        label: "Anprints",
        description: "",
        logo: "anprints.png",
        enable: false
    }, {
        value: "hogotopod",
        label: "Hogotopod",
        description: "",
        logo: "hogotopod.png",
        enable: false
    }, {
        value: "dreamship",
        label: "Dreamship",
        description: "",
        logo: "dreamship.png",
        enable: false
    }, {
        value: "printdoors",
        label: "Printdoors",
        description: "",
        logo: "printdoors.png",
        enable: false
    }, {
        value: "merchfox",
        label: "Merchfox",
        description: "",
        logo: "merchfox.png",
        enable: false
    }, {
        value: "printory",
        label: "Printory",
        description: "",
        logo: "printory.png",
        enable: false
    }, {
        value: "treesprint",
        label: "Treesprint",
        description: "",
        logo: "treesprint.png",
        enable: false
    }, {
        value: "bullstart",
        label: "Bullstart",
        description: "",
        logo: "bullstart.png",
        enable: false
    }]);
    var { listprinters } = props.printer;
    var { getListPrinters, deletePrinter } = props;
    // const { t } = useTranslation();

    useEffect(() => {
        getListPrinters(1, 9999);
    }, [getListPrinters]);

    useEffect(() => {
        setAllPrinters((prev) => {
            return prev.map((v, i) => {
                return {
                    ...v,
                    enable: listprinters?.some((v2, i2) => v2?.printer === v?.value)
                }
            });
        });
    }, [listprinters]);

    const onChange = (e, data) => {
        if (e.target.checked) {
            onClickOpenModalAddPrinter(data);
        } else {
            var find = listprinters.find((v, i) => v?.printer === data?.value);
            if (find) {
                deletePrinter(find);
            }
        }
    }

    const onClickOpenModalAddPrinter = (data) => {
        setIsOpenModalAddPrinter(!isOpenModalAddPrinter);
        setPrinterSelected(data?.value);
    };

    return (
        <Fragment>
            <div className="row g-6 g-xl-9">
                {allPrinters.map((v, i) => (
                    <div className="col-md-6 col-xxl-3">
                        <div className="card">
                            {v?.value === "cotik" && (<div className="ribbon ribbon-triangle ribbon-top-end border-success">
                                <div className="ribbon-icon mt-n6">
                                    <i className="ki-outline ki-like fs-2 text-white mt-n1"></i>
                                </div>
                            </div>)}
                            <div className="card-body d-flex align-items-center pt-12 p-9 gap-3">
                                <div className={cx("mb-5", { "symbol": v?.value !== "lizyprintfull", "symbol-65px": v?.value !== "lizyprintfull" })}>
                                    <img src={require(`components/assets/media/logo-print/${v?.logo}`)} alt="" className={cx({ "bg-dark": v?.value === "thgfulfill" })} width={v?.value !== "lizyprintfull" ? "65": "160"} height="65" />
                                </div>
                                <div className="d-flex flex-column lh-lg">
                                    <Link to="#" className="fs-4 text-gray-800 text-hover-primary fw-bold mb-0">{v?.label}</Link>
                                    <div className="fw-semibold text-gray-500 mb-6">{v?.description}</div>
                                </div>
                                <div className={cx("form-check form-check-solid form-switch form-check-custom fv-row position-absolute", { "d-none": v?.value === "cotik" })} style={{ "top": "8px", "right": "0px" }}>
                                    <input type="checkbox" className="form-check-input w-45px h-30px" value={!v?.enable} id="enable" name="enable" checked={v?.enable} onChange={(e) => { onChange(e, v) }} />
                                    <label className="form-check-label" htmlFor="enable"></label>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            {isOpenModalAddPrinter ? <Modaladdprinter openModal={onClickOpenModalAddPrinter} isOpenModalAddPrinter={isOpenModalAddPrinter} printer_selected={printer_selected} /> : ""}
        </Fragment>
    );
}

Listprinters.propTypes = {
    getListPrinters: PropTypes.func.isRequired,
    deletePrinter: PropTypes.func.isRequired,
};
const mapStateToProps = state => ({
    printer: state.printer
});
const mapDispatchToProps = {
    getListPrinters,
    deletePrinter,
}

export default connect(mapStateToProps, mapDispatchToProps)(Listprinters);